import { render, staticRenderFns } from "./AssetForm.vue?vue&type=template&id=fd2e7050&scoped=true"
import script from "./AssetForm.vue?vue&type=script&lang=js"
export * from "./AssetForm.vue?vue&type=script&lang=js"
import style0 from "./AssetForm.vue?vue&type=style&index=0&id=fd2e7050&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd2e7050",
  null
  
)

export default component.exports